















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { PaycheckForm, PaycheckFormLine } from './PaycheckForm';
import Decimal from '@/utils/decimal';

const vacationMoneyAltinnDescription = 'feriepenger';

@Component
export default class PaycheckTaxSummary extends Vue {
  @Prop({ type: Object, required: true }) private paycheck!: PaycheckForm;
  @Prop({ type: Boolean, default: false }) private isPrint!: boolean;

   private get vacationMoneyBaseAmount(): Decimal {
    return (this.paycheck.paycheckLines as PaycheckFormLine[])
      .filter(line => line.includeInVacationMoneyBase)
      .reduce((sum, line) => sum.add(line.sum), new Decimal(0));
  }

  private get vacationMoneyAmount(): Decimal {
    return this.vacationMoneyBaseAmount
      .times(this.paycheck.vacationMoneyPercentage).dividedBy(100);
  }

  private get vacationMoneyEmployerTaxAmount(): Decimal {
    return (this.paycheck.paycheckLines as PaycheckFormLine[])
      .filter(line => line.includeInVacationMoneyBase)
      .filter(line => line.employerTaxable)
      .reduce((sum, line) => sum.add(line.sum), new Decimal(0))
      .times(this.paycheck.vacationMoneyPercentage).dividedBy(100)
      .times(this.paycheck.companyMunicipalityTaxRate).dividedBy(100);
  }

  private get employerTaxAmount(): Decimal {
    return (this.paycheck.paycheckLines as PaycheckFormLine[])
      .filter(line => line.employerTaxable)
      .filter(line => line.altinnDescription !== vacationMoneyAltinnDescription)
      .reduce((sum, line) => sum.add(line.sum), new Decimal(0))
      .times(this.paycheck.companyMunicipalityTaxRate).dividedBy(100);
  }

  private get paidVacationMoneyEmployerTaxAmount(): Decimal {
    return (this.paycheck.paycheckLines as PaycheckFormLine[])
      .filter(line => line.employerTaxable)
      .filter(line => line.altinnDescription === vacationMoneyAltinnDescription)
      .reduce((sum, line) => sum.add(line.sum), new Decimal(0))
      .times(this.paycheck.companyMunicipalityTaxRate).dividedBy(100);
  }
}
